const initialState = {
  companies: [],
  optionList:[],
  companiesList:[],
  companySelectedList:[],
  checkedCompany:{},
  gpId: null,
  term: null,
  planOptions: null,
  error: null,
  company_data: [],
};

const companyselectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_COMPANY_SELECTION_SUCCESS':
      
        return {
        ...state,
        companies: action.payload,
        error: null,
      };
    case 'POST_CHECKED_COMPANY_SUCCESS':
        
        return {
        ...state,
        checkedCompany: action.payload,
        error: null,
      };
    case 'FETCH_COMPANY_SELECTION_OPTION_SUCCESS':
        
        return {
        ...state,
        optionList: action.payload,
        error: null,
      };
    case 'GET_AGENCY_CODE_USER_PSW_SUCCESS':        
        return {
        ...state,
        company_data: action.payload,
        error: null,
      };      
    case 'FETCH_COMPANY_DETAILS_SUCCESS':
        
        return {
        ...state,
        companiesList: action.payload,
        error: null,
      };
    case 'FETCH_COMPANY_METADATA_SUCCESS': // New action type
    return {
      ...state,
      gpId: action.payload.gpId,
      term: action.payload.term,
      planOptions: action.payload.planOptions,
      error: null,
    };
    case 'RESET_COMPANY_SELECTION':
      return { ...state, companiesList: [] };
    case 'FETCH_COMPANY_SELECTION_FAILURE':
       
        return {
        ...state,
        error: action.payload,
      };
    case 'FETCH_COMPANY_SELECTION_OPTION_FAILURE':
       
        return {
        ...state,
        error: action.payload,
      };
      case 'DELETE_CARRIER_GROUP':
        return { ...state, companies: action.payload, error: null };
    default:
      return state;
  }
};

export default companyselectionReducer;

